export default "__VITE_ASSET__BumJe4P6__"